import routerResolver from '%evp_ticket_frontend/js/react/service/RouteResolver';
import withPathParams, { getMatchParams as commonMatchParams } from '%app/js/common/components/withPathParams';

export default withPathParams(routerResolver);

export const getMatchParams = (path, routeId) => commonMatchParams(path, routeId, routerResolver);
